module.exports = "/assets/data/5e6244fcdef2ffaf379cee10e98c13a5-S3.data.json";